<template>
  <div>
    <v-dialog v-model="dialogShowForm" :max-width="dialogwidth" persistent>
      <v-form ref="form" lazy-validation class="white-bg">
        <v-container>
          <v-row>
            <v-col cols="6" sm="6" md="6" class="d-flex align-center">
              <span class="font-head ml-2">รายงานการทำงาน</span>
            </v-col>
            <v-col cols="6" sm="6" md="6" class="d-flex justify-end">
              <v-btn
                class="mx-2"
                fab
                small
                dark
                color="white"
                :style="styleCloseBt"
                @click="closeDialog()"
              >
                X
              </v-btn>
            </v-col>
          </v-row>
          <v-row>
            <MultiUpload
              ref="multiUploadBefore"
              :minImg="minImgs"
              :limitImg="9"
              :TitleTxt="'BEFORE'"
              :TypeKey="'beforeImage'"
              :defaultArray="imageDataValSrc['beforeImage']"
              :defaultInputArray="imageDataVal['beforeImage']"
              @ReturnURL="getUrl"
              :checkError="imageDataVal.beforeImage.length"
            ></MultiUpload>
          </v-row>
          <v-row>
            <MultiUpload
              ref="multiUploadAfter"
              :minImg="minImgs"
              :limitImg="9"
              :TitleTxt="'AFTER'"
              :TypeKey="'afterImage'"
              :defaultArray="imageDataValSrc['afterImage']"
              :defaultInputArray="imageDataVal['afterImage']"
              @ReturnURL="getUrl"
              :checkError="imageDataVal.afterImage.length"
            ></MultiUpload>
          </v-row>
          <v-row class="pb-0">
            <v-col
              v-if="
                shopId !== shopNameData.ayasan &&
                  shopId !== shopNameData.assa &&
                  shopId !== shopNameData.numchai &&
                  shopId !== shopNameData.puenBaan &&
                  shopId !== shopNameData.creativeliveidea
              "
              cols="6"
              sm="6"
              md="6"
              class="pr-1"
            >
              <div class="mb-2 font-sub-head">อุณหภูมิก่อนล้าง</div>
              <v-text-field
                v-model="detailsForm.beforeAir"
                outlined
                dense
                class="custom-outlined-textfield"
                color="black"
                :rules="rules.required"
                type="number"
                suffix="องศา"
                step="any"
              ></v-text-field>
            </v-col>
            <v-col
              v-if="
                shopId !== shopNameData.ayasan &&
                  shopId !== shopNameData.assa &&
                  shopId !== shopNameData.puenBaan &&
                  shopId !== shopNameData.numchai &&
                  shopId !== shopNameData.creativeliveidea
              "
              cols="6"
              sm="6"
              md="6"
              class="pl-1"
            >
              <div class="mb-2 font-sub-head">อุณหภูมิหลังล้าง</div>
              <v-text-field
                v-model="detailsForm.afterAir"
                outlined
                dense
                class="custom-outlined-textfield"
                color="black"
                :rules="rules.required"
                type="number"
                suffix="องศา"
                step="any"
              ></v-text-field>
            </v-col>
          </v-row>
          <v-row class="pb-0">
            <v-col cols="12" sm="12" md="12">
              <div class="mb-2 font-sub-head">รายละเอียดเพิ่มเติม</div>
              <v-textarea
                v-model="detailsForm.remark"
                name="input-details"
                value=""
                placeholder="กรอกรายละเอียดเพิ่มเติม"
                outlined
                hide-details="auto"
                class="custom-outlined-textarea small-placeholder"
                color="black"
                :rules="rules.required"
              ></v-textarea>
            </v-col>
          </v-row>
          <v-row class="pb-0">
            <v-col cols="12" sm="12" md="12">
              <div class="mb-2 font-sub-head" v-if="shopId != 'SD_1774575719812'">ทรัพย์สินสูญหายหรือไม่</div>
              <div class="mb-2 font-sub-head" v-else>The coffee machine operation</div>
              <v-radio-group
                v-model="detailsForm.checkBox1"
                @change="detailsForm.remarkCheckbox1 = ''"
                row
                class="shrink ml-2 mr-0 mt-0 mb-2"
                required
                :rules="rules.required"
              >
                <v-radio :value="shopId != 'SD_1774575719812' ? 'มีทรัพย์สินสูญหาย' : 'normal'">
                  <template v-slot:label>
                    <div class="mt-1">
                      <strong v-if="shopId != 'SD_1774575719812'">มีทรัพย์สินสูญหาย</strong>
                      <strong v-else>normal</strong>
                    </div>
                  </template>
                </v-radio>
                <v-radio :value="shopId != 'SD_1774575719812' ? 'ไม่มีทรัพย์สินสูญหาย' : 'abnormal'">
                  <template v-slot:label>
                    <div class="mt-1">
                      <strong v-if="shopId != 'SD_1774575719812'">ไม่มีทรัพย์สินสูญหาย</strong>
                      <strong v-else>abnormal</strong>
                    </div>
                  </template>
                </v-radio>
              </v-radio-group>
            </v-col>
            <v-col
              cols="12"
              v-if="detailsForm.checkBox1 == 'มีทรัพย์สินสูญหาย'"
              sm="12"
              md="12"
            >
              <div class="mb-2 font-sub-head">หมายเหตุทรัพย์สินสูญหาย</div>
              <v-textarea
                v-if="detailsForm.checkBox1 == 'มีทรัพย์สินสูญหาย'"
                v-model="detailsForm.remarkCheckbox1"
                name="input-details"
                value=""
                placeholder="หมายเหตุทรัพย์สินสูญหาย"
                outlined
                hide-details="auto"
                class="custom-outlined-textarea small-placeholder"
                color="black"
                :rules="rules.required"
              ></v-textarea>
            </v-col>
            <!-- <v-col cols="12" sm="12" md="12">
             <v-text-field
                v-if="detailsForm.checkBox1 == 'มีทรัพย์สินสูญหาย'"
                v-model="detailsForm.remarkCheckbox1"
                outlined
                dense
                class="custom-outlined-textfield"
                color="black"
                :rules="rules.required"
                prefix="หมายเหตุ"
                step="any"
              ></v-text-field>
              </v-col> -->
            <!-- <v-col cols="12" sm="12" md="12">
              <v-checkbox
                false-value="มีทรัพย์สินสูญหาย"
                true-value="ไม่มีทรัพย์สินสูญหาย"
                v-model="detailsForm.checkBox1"
                hide-details
                class="shrink ml-2 mr-0 mt-0 mb-2"
                label="ไม่มีทรัพย์สินสูญหาย"
              ></v-checkbox>
            </v-col> -->

            <!-- <v-col cols="12" sm="12" md="12">
              <v-checkbox
                false-value="มีทรัพย์สินเสียหาย"
                true-value="ไม่มีทรัพย์สินเสียหาย"
                v-model="detailsForm.checkBox2"
                hide-details
                class="shrink ml-2 mr-0 mt-0 mb-2"
                label="ไม่มีทรัพย์สินเสียหาย"
              ></v-checkbox>
            </v-col> -->
            <v-col cols="12" sm="12" md="12">
              <div class="mb-2 font-sub-head" v-if="shopId != 'SD_1774575719812'">ทรัพย์สินเสียหายหรือไม่</div>
              <div class="mb-2 font-sub-head" v-else>Test Espresso 1 shot</div>
              <v-radio-group
                v-model="detailsForm.checkBox2"
                @change="detailsForm.remarkCheckbox2 = ''"
                row
                class="shrink ml-2 mr-0 mt-0 mb-2"
                required
                :rules="rules.required"
              >
                <v-radio :value="shopId != 'SD_1774575719812' ? 'มีทรัพย์สินเสียหาย' : 'normal'">
                  <template v-slot:label>
                    <div class="mt-1">
                      <strong v-if="shopId != 'SD_1774575719812'">มีทรัพย์สินเสียหาย</strong>
                      <strong v-else>normal</strong>
                    </div>
                  </template>
                </v-radio>
                <v-radio :value="shopId != 'SD_1774575719812' ? 'ไม่มีทรัพย์สินเสียหาย' : 'abnormal'">
                  <template v-slot:label>
                    <div class="mt-1">
                      <strong v-if="shopId != 'SD_1774575719812'">ไม่มีทรัพย์สินเสียหาย</strong>
                      <strong v-else>abnormal</strong>
                    </div>
                  </template>
                </v-radio>
              </v-radio-group>
            </v-col>
            <v-col
              v-if="detailsForm.checkBox2 == 'มีทรัพย์สินเสียหาย'"
              cols="12"
              sm="12"
              md="12"
            >
              <div class="mb-2 font-sub-head">หมายเหตุทรัพย์สินสูญหาย</div>
              <v-textarea
                v-if="detailsForm.checkBox2 == 'มีทรัพย์สินเสียหาย'"
                v-model="detailsForm.remarkCheckbox2"
                name="input-details"
                value=""
                placeholder="หมายเหตุทรัพย์สินสูญหาย"
                outlined
                hide-details="auto"
                class="custom-outlined-textarea small-placeholder"
                color="black"
                :rules="rules.required"
              ></v-textarea>
            </v-col>

            <v-col cols="12" sm="12" md="12">
              <div class="mb-2 font-sub-head" v-if="shopId != 'SD_1774575719812'">หน้างานสะอาดหรือไม่</div>
              <div class="mb-2 font-sub-head" v-else>Coffee grind size normal</div>
              <v-radio-group
                v-model="detailsForm.redio1"
                row
                class="shrink ml-2 mr-0 mt-0 mb-2"
                required
                :rules="rules.required"
              >
                <v-radio :value="shopId != 'SD_1774575719812' ? 'สะอาด' : 'abnormal'">
                  <template v-slot:label>
                    <div class="mt-1">
                      <strong v-if="shopId != 'SD_1774575719812'">สะอาด</strong>
                      <strong v-else>normal</strong>
                    </div>
                  </template>
                </v-radio>
                <v-radio value="ไม่สะอาด">
                  <template v-slot:label>
                    <div class="mt-1">
                      <strong v-if="shopId != 'SD_1774575719812'">ไม่สะอาด</strong>
                      <strong v-else>abnormal</strong>
                    </div>
                  </template>
                </v-radio>
              </v-radio-group>
            </v-col>
          </v-row>
          <!-- <v-col
              v-if="shopId == shopNameData.assa "
              cols="12"
              sm="12"
              md="12"
            >
              <div class="mb-2 font-sub-head">หมายเหตุทรัพย์สินสูญหาย</div>
              <v-textarea
                v-model="detailsForm.remarkCheckbox2"
                name="input-details"
                value=""
                placeholder="หมายเหตุทรัพย์สินสูญหาย"
                outlined
                hide-details="auto"
                class="custom-outlined-textarea small-placeholder"
                color="black"
                :rules="rules.required"
              ></v-textarea>
            </v-col> -->

          <v-row class="pb-0" v-if="shopId === shopNameData.assa">
            <v-col cols="12" sm="12" md="12">
              <div class="mb-2 font-sub-head">Serial Number</div>
               <v-text-field
                v-if="shopId === shopNameData.assa"
                v-model="detailsForm.remarkDetail"
                outlined
                dense
                class="custom-outlined-textfield"
                color="black"
                :rules="rules.required"
                step="any"
              ></v-text-field>
            </v-col>
          </v-row>
          <v-row>
            <v-col
              v-if="detailsForm.signatureURL"
              class="d-flex justify-space-between"
            >
              <v-col class="pa-0 d-flex align-center">
                <span class="font-sub-head">ลายเซ็น</span>
              </v-col>
              <v-btn
                @click="editSign()"
                outlined
                style="border-color: #8A8D93; color: #8A8D93; text-transform: none;"
                class="font-sub-btn"
              >
                แก้ไขลายเซ็น</v-btn
              >
            </v-col>
          </v-row>
          <v-row>
            <v-col
              v-if="detailsForm.signatureURL"
              class="d-flex justify-center"
            >
              <img
                :src="detailsForm.signatureURL"
                style="max-width: 100%; max-height: 100%; object-fit: contain;"
              />
            </v-col>
            <SignaturePad
              v-else
              ShowBtnSave="true"
              ref="signaturePad"
              :TitleTxt="'ลายเซ็น'"
              @ReturnImgBase64="saveSign"
            ></SignaturePad>
          </v-row>
          <v-row cols="12">
            <v-col cols="5" sm="5" md="5" class="pr-1">
              <v-btn
                class="font-btn-cancel"
                elevation="2"
                block
                color="#D2D1D3"
                dark
                @click="closeDialog()"
                >ยกเลิก</v-btn
              >
            </v-col>
            <v-col cols="7" sm="7" md="7" class="pl-1">
              <v-btn
                class="font-btn"
                elevation="2"
                block
                color="#1B437C"
                dark
                @click="addDataForm"
                >บันทึก</v-btn
              >
            </v-col>
          </v-row>
        </v-container>
        <v-overlay :value="loadingAdd">
          <v-progress-circular indeterminate size="64"></v-progress-circular>
        </v-overlay>
      </v-form>
    </v-dialog>
  </div>
</template>

<script>
import SignaturePad from '../SignaturePad/SignaturePad.vue'
import MultiUpload from '../PdfForm/multiUpload.vue'
import axios from 'axios'
export default {
  components: { SignaturePad, MultiUpload },
  props: {
    dialogShowForm: { type: Boolean, required: true },
    dialogwidth: { type: String, required: true },
    getImgSignature: { type: Function },
    closeDialog: { type: Function },
    loadingAdd: { type: Boolean },
    jobId: { type: Number },
    detailsForm: { type: Object },
    getSaveURL: { type: Function },
    minImgs: { type: Number },
    shopId: { type: String }
  },
  data () {
    return {
      imageDataVal: {
        beforeImage: [],
        afterImage: []
      },
      imageDataValSrc: {
        beforeImage: [''],
        afterImage: ['']
      },
      imageBase64: null,
      rules: {
        required: [v => !!v || 'กรุณากรอกข้อมูล']
      }
    }
  },
  async mounted () {
    await this.getMultiImage()
    await this.getSaveURL()
  },
  methods: {
    saveSign (e) {
      this.dataSign = e
    },
    async getMultiImage () {
      try {
        await this.$emit('updateDialogLoading', true)
        // eslint-disable-next-line no-unused-expressions
        // const getImg = await axios.get('http://localhost:5001/formpdf/getmultiimage?jobId=' + this.jobId)
        const getImg = await axios.get(
          this.$DNS_IP + '/formpdf/getmultiimage?jobId=' + this.jobId
        )
        if (getImg.data.data.length) {
          for (const i of getImg.data.data) {
            if (i.beforeafter !== null) {
              this.imageDataValSrc[i.typeUpload].push(i.beforeafter)
              await this.convertBase64ToFile(i)
            }
            // this.imageDataValSrc[i.typeUpload].push(i.urlDomain)
          }
          this.$emit('updateDialogLoading', false)
        }
        this.$emit('updateDialogLoading', false)
      } catch (err) {
        this.$emit('updateDialogLoading', false)
      }
    },
    // convertBase64ToFile (imgBase64) {
    //   try {
    //     const data = 'data:image/jpeg;base64,' + imgBase64.urlDomain
    //     const [header, base64String] = data.split(',')
    //     const mime = header.match(/:(.*?);/)[1]
    //     const byteString = atob(base64String)
    //     const ab = new ArrayBuffer(byteString.length)
    //     const ia = new Uint8Array(ab)
    //     for (let i = 0; i < byteString.length; i++) {
    //       ia[i] = byteString.charCodeAt(i)
    //     }
    //     const blob = new Blob([ab], { type: mime })
    //     const file = new File([blob], 'image.png', { type: mime })
    //     const dataTransfer = new DataTransfer()
    //     dataTransfer.items.add(file)
    //     this.imageBase64 = dataTransfer.files
    //     this.imageDataVal[imgBase64.typeUpload].push(file)
    //   } catch (err) {
    //     console.error('Invalid Base64 String:', err)
    //   }
    // },
    async convertBase64ToFile (imgUrl) {
      const response = await fetch(imgUrl.beforeafter, { mode: 'cors' })
      const blob = await response.blob()
      const mime = blob.type || 'image/png'
      const file = new File(
        [blob],
        imgUrl.beforeafter.split('betask-linked/static/upload/BeforeAfter/')[1],
        { type: mime }
      )
      const dataTransfer = new DataTransfer()
      dataTransfer.items.add(file)
      this.imageBase64 = dataTransfer.files
      this.imageDataVal[imgUrl.typeUpload].push(file)
    },
    async addDataForm (x) {
      console.log('adddddd', this.jobId)
      // if -> ยังไม่เคยมีรูปภาพลายเซ็น (กรอกฟอร์ม/วาดลายเซ็นครั้งแรก)
      // this.$refs.signaturePad จะเก็บค่าการวาดลายเซ็นบน canvas แล้วส่งค่านี้ไป save เป็นรูปภาพที่ saveSignature function ของ component SignaturePad
      this.$nextTick(async () => {
        console.log('298')
        let self = this
        console.log('self >>>', self)
        self.$refs.form.validate()
        console.log('XXXXX : ', self.$refs.form.validate())
        if (!self.$refs.form.validate()) {
          this.$swal('คำเตือน', 'โปรดกรอกข้อมูลให้ครบถ้วน!!', 'warning')
        } else {
          if (this.$refs.signaturePad !== undefined) {
            this.detailsForm.signatureURL = await this.$refs.signaturePad.saveSignature()
            console.log('290')
          } else {
            console.log('294')
            this.detailsForm.signatureURL = this.detailsForm.signatureURL
          }

          // เช็คว่าถ้าไม่มีรูปภาพลายเซ็นเดิม และ ไม่มีการวาดลายเซ็นใหม่ ตอนกดบันทึกฟอร์มจะขึ้นแจ้งเตือน
          if (!this.dataSign && !this.detailsForm.signatureURL) {
            console.log('304')
            this.$swal('คำเตือน', 'โปรดกรอกข้อมูลให้ครบถ้วน!', 'warning')
          } else {
            console.log('307')
            if (
              this.shopId === this.shopNameData.airmate &&
              (this.detailsForm.beforeAir === '' ||
                this.detailsForm.afterAir === '')
            ) {
              console.log('309')
              this.$swal('คำเตือน', 'โปรดกรอกข้อมูลให้ครบถ้วน!!', 'warning')
            } else {
              console.log('312')
              this.imageDataVal[x.key] = x.vals // ใช้ตัวนี้ในการส่งค่าไปยังหลังบ้าน เพื่ออัพโหลด //
              this.$emit('ReturnURL', {
                multiImg: this.imageDataVal,
                detailsForm: this.detailsForm,
                dataSign: this.dataSign,
                jobId: this.jobId
              })
            }
          }
        }
      })
      // if (!chkv) {
      //   this.$swal('คำเตือน', 'โปรดกรอกข้อมูลให้ครบถ้วน!', 'warning')
      //   return false
      // }
    },
    async getUrl (x) {
      if (x.vals !== undefined) {
        this.imageDataVal[x.key] = x.vals // ใช้ตัวนี้ในการส่งค่าไปยังหลังบ้าย เพื่ออัพโหลด //
      } else {
        this.imageDataVal[x.key] = []
      }
    },
    editSign () {
      this.detailsForm.signatureURL = ''
    }
  }
}
</script>

<style>
.font-sub-head {
  font-size: 16px;
  font-weight: 600;
}
.white-bg {
  background-color: white;
}
.font-head {
  font-size: 20px;
  font-weight: 600;
}
.custom-outlined-textarea.v-text-field--outlined >>> fieldset {
  border: solid 1px;
  border-radius: 8px;
  border-color: rgba(46, 38, 61, 0.12);
}
.small-placeholder ::placeholder {
  font-size: 12px;
}
.custom-outlined-textfield.v-text-field--outlined >>> fieldset {
  border: solid 1px;
  border-radius: 8px;
  border-color: rgba(46, 38, 61, 0.12);
}
.font-btn-cancel {
  font-size: 20px;
  font-weight: 600;
  color: #2e263d;
  opacity: 0.55;
}
.font-btn {
  font-size: 20px;
  font-weight: 600;
}
</style>



// WEBPACK FOOTER //
// src/components/PdfForm/dialogForm.vue